import React from "react";
import { Link } from "react-router-dom";

const TABS = [
  { to: "/admin/patients", label: "Patients & documents" },
  { to: "/admin/bookings", label: "Bookings" },
  { to: "/admin/calendar", label: "Calendar" },
  { to: "/admin/availability", label: "Availability" },
  { to: "/admin/enquiries", label: "Enquiries" },
  { to: "/admin/payments", label: "Take a payment" },
  { to: "/admin/returns", label: "Monitor returns" },
  { to: "/admin/team", label: "Team" },
];

export const AdminTabs = ({ active }) => (
  <div className="mt-3 flex flex-wrap gap-x-4 gap-y-2 text-sm" data-testid="admin-tabs">
    {TABS.map((t) =>
      t.to === active ? (
        <span key={t.to} data-testid={`admin-tab-${t.label.split(" ")[0].toLowerCase()}`} className="text-bronze-dark border-b border-bronze-dark">{t.label}</span>
      ) : (
        <Link key={t.to} to={t.to} data-testid={`admin-tab-${t.label.split(" ")[0].toLowerCase()}`}
          className="text-ink hover:text-bronze-dark">{t.label}</Link>
      ),
    )}
  </div>
);
